"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultClassToggle = void 0;
var defaultClassToggle_1 = require("./defaultClassToggle");
Object.defineProperty(exports, "DefaultClassToggle", { enumerable: true, get: function () { return __importDefault(defaultClassToggle_1).default; } });
